import React, { Component } from 'react';
import logo from '../../assets/images/MHS_LOGO.jpg';

class Loading extends Component {
    handler;
    n = 0;
    
    constructor(props) {
        super(props);

        this.state = { loadingText: 'Loading' };
    }

    componentDidMount() {
        this.handler = setInterval(() => {
            this.n += 1;

        this.setState({loadingText: <div><span style={{color: 'transparent'}}>{Array(this.n).join(".")}</span>Loading{Array(this.n).join(".")}</div>});

            if (this.n >= 4) {
                this.n = 0;
            }
        }, 500)
    }

    componentWillUnmount() {
        clearInterval(this.handler);
    }

    render() {
        return (
            <div className="loading">
                <div>
                    <img src={logo} alt="Logo" className="main-logo" />
                    <div>{this.state.loadingText}</div>
                </div>
            </div>
        )
    }
}

export default Loading;